(ns rlws.iot-cloud.frontend.admin
  (:require [re-frame.core :as rf]
            [rlws.iot-cloud.frontend.global-messages :as message]
            [rlws.iot-cloud.frontend.subscriptions :as sub]
            [rlws.iot-cloud.frontend.ajax :as ajax]
            [rlws.iot-cloud.frontend.home.components :as components]))

(rf/reg-event-fx
  ::send-test-alert
  (fn [_ _]
    (ajax/post-request
      "/api/v1/admin/alert"
      {:message :global-message/add
       :data    (message/error "Alert! Scale Error")}
      [::test-alert-success]
      [:generic-failure])))

(defn recent-alerts []
  (let [alerts (take 10 @(rf/subscribe [::sub/complete-alerts]))]
    [components/event-list "Recent Alerts"
     alerts
     components/alert-card
     (components/empty-list-template "No recent Alerts")]))

(defn recent-service-notes []
  (let [service-notes (take 10 @(rf/subscribe [::sub/service-notes]))]
    [components/event-list "Most Recent Service Notes"
     service-notes
     components/service-note-card
     (components/empty-list-template "No recent Service Notes")]))

(defn assets-under-watch []
  (let [scales @(rf/subscribe [::sub/scales-under-watch])]
    [components/card-list "Assets under watch"
     scales
     components/asset-under-watch-template
     (components/empty-list-template "No Assets under watch")
     :crux.db/id]))

(defn emulation-mode-scales []
  (let [scales @(rf/subscribe [::sub/complete-scales])
        emulated-scales (filterv #(= (:state (:status %)) :warning) scales)]
    [components/card-list "Emulation Mode Scales"
     emulated-scales
     components/emulation-scale-template
     (components/empty-list-template "No Emulation Mode Scales")
     :crux.db/id]))

(defn home
  []
  (let [page-title @(rf/subscribe [::sub/page-title])]
    [:<>
     [:div.flex.flex-col
      [:h1.text-lg.margin-bottom-sm page-title]
      [:div.flex.md:flex-row.flex-col
       [:div {:class ["md:w-1/4" "mx-2"]}
        [recent-alerts]]
       [:div {:class ["md:w-1/2" "mx-2"]}
        [recent-service-notes]]
       [:div {:class ["md:w-1/4" "mx-2"]}
        [:div.flex.flex-col
         [assets-under-watch]
         [emulation-mode-scales]]]]]]))
